// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1ypfg","obliqueLineWrap":"membershipbadge_obliqueLineWrap__-BFWO","obliqueLine":"membershipbadge_obliqueLine__2Ssn5"};